import { render, staticRenderFns } from "./StructureFree.vue?vue&type=template&id=4b8ca3a0&scoped=true"
import script from "./StructureFree.vue?vue&type=script&lang=js"
export * from "./StructureFree.vue?vue&type=script&lang=js"
import style0 from "./StructureFree.vue?vue&type=style&index=0&id=4b8ca3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ca3a0",
  null
  
)

export default component.exports